
    const data = {"name":"src/core/icons/check-bold","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m9 20.42-6.21-6.21 2.83-2.83L9 14.77l9.88-9.89 2.83 2.83L9 20.42Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            